import React from 'react';
import { Box, Heading, SimpleGrid } from '@chakra-ui/core';

import lile from '../../images/lile.jpg';
import lyon from '../../images/lyon.jpg';
import grenoble from '../../images/grenoble.jpg';
import paris from '../../images/paris.jpg';
import saint from '../../images/saint.jpeg';

export default function Ville() {
  return (
    // <Flex
    //   direction={['column', 'column', 'row', 'row']}
    //   justifyContent="center"
    //   align="center"
    // >
    <SimpleGrid columns={[1, 2, 3, 5]}>
      <Box
        position="relative"
        shadow="md"
        rounded="20px"
        // w={['100%', '100%', '20%', '20%']}
        bg="black"
        m="2"
        h="350px"
        style={{
          background: ` linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('${lyon}')`,
        }}
        className="detail-image"
      >
        <Heading
          top="50%"
          opacity="0.8"
          left="0"
          right="0"
          color="white"
          size="xl"
          position="absolute"
        >
          Lyon
        </Heading>
        {/* <Image
          opacity="0.6"
          bgSize="cover"
          rounded="20px"
            w={['100%', '100%', '100%', '100%']}
            h="350px"
            objectFit="fill"
          src={lyon}
        ></Image> */}
      </Box>
      <Box
        position="relative"
        shadow="md"
        rounded="20px"
        // w={['100%', '100%', '20%', '20%']}
        bg="black"
        m="2"
        h="350px"
        style={{
          background: ` linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('${paris}')`,
        }}
        className="detail-image"
      >
        <Heading
          top="50%"
          opacity="0.8"
          left="0"
          right="0"
          color="white"
          size="xl"
          position="absolute"
        >
          Paris
        </Heading>
        {/* <Image
          opacity="0.6"
          bgSize="cover"
          rounded="20px"
            w={['100%', '100%', '100%', '100%']}
            h="350px"
            objectFit="fill"
          src={paris}
        ></Image> */}
      </Box>
      <Box
        position="relative"
        shadow="md"
        rounded="20px"
        // w={['100%', '100%', '20%', '20%']}
        bg="black"
        m="2"
        h="350px"
        style={{
          background: ` linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('${grenoble}')`,
        }}
        className="detail-image"
      >
        <Heading
          top="50%"
          opacity="0.8"
          left="0"
          right="0"
          color="white"
          size="xl"
          position="absolute"
        >
          Grenoble
        </Heading>
        {/* <Image
          opacity="0.6"
          bgSize="cover"
          rounded="20px"
            w={['100%', '100%', '100%', '100%']}
            h="350px"
            objectFit="fill"
          src={grenoble}
        ></Image> */}
      </Box>
      <Box
        position="relative"
        shadow="md"
        rounded="20px"
        // w={['100%', '100%', '20%', '20%']}
        bg="black"
        m="2"
        h="350px"
        style={{
          background: ` linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('${saint}')`,
        }}
        className="detail-image"
      >
        <Heading
          top="50%"
          opacity="0.8"
          left="0"
          right="0"
          color="white"
          size="xl"
          position="absolute"
        >
          Saint-Étienne
        </Heading>
        {/* <Image
          opacity="0.6"
          bgSize="cover"
          rounded="20px"
            w={['100%', '100%', '100%', '100%']}
            h="350px"
            objectFit="fill"
          src={saint}
        ></Image> */}
      </Box>
      <Box
        position="relative"
        shadow="md"
        rounded="20px"
        // w={['100%', '100%', '20%', '20%']}
        bg="black"
        m="2"
        h="350px"
        style={{
          background: ` linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('${lile}')`,
        }}
        className="detail-image"
      >
        <Heading
          top="50%"
          opacity="0.8"
          left="0"
          right="0"
          color="white"
          size="xl"
          position="absolute"
        >
          Lille
        </Heading>
        {/* <Image
          opacity="0.6"
          bgSize="cover"
          rounded="20px"
            w={['100%', '100%', '100%', '100%']}
            h="350px"
            objectFit="fill"
          src={lile}
        ></Image> */}
      </Box>
    </SimpleGrid>

    // </Flex>
  );
}
